// src/Onboarding.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // 1. Import useNavigate

const API_BASE_URL = window.location.hostname === 'localhost' ? 'http://localhost:7071' : '';

function Onboarding({ user, onOnboardingSuccess }) {
    const [orgName, setOrgName] = useState('');
    const [workspaceId, setWorkspaceId] = useState('');
    const [tenantId, setTenantId] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate(); // 2. Initialize the navigate function

    const myAppClientId = "7149e564-84b7-4079-b766-d0dc42c08b37";
    const redirectUri = `${window.location.origin}/api/post-consent-setup`;
    const consentUrl = `https://login.microsoftonline.com/common/adminconsent?client_id=${myAppClientId}&redirect_uri=${redirectUri}`;

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        setError(null);

        try {
            const response = await fetch(`${API_BASE_URL}/api/onboard/customer`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    organizationName: orgName,
                    logAnalyticsWorkspaceId: workspaceId,
                    azureTenantId: tenantId
                }),
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(errorText || `Request failed with status ${response.status}`);
            }

            // --- 3. THIS IS THE CORRECTED LOGIC ---
            // On successful onboarding, navigate directly to the pricing page.
            navigate('/pricing');
            // ----------------------------------------

        } catch (e) {
            setError(e.message);
            console.error("Onboarding failed:", e);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="onboarding-container">
            <h2>Welcome to Compliance Guardian, {user.userDetails}!</h2>
            <p>To get started, we need two things: permission to access your logs and some basic configuration.</p>

            <div className="onboarding-step">
                <h3>Step 1: Grant Permissions</h3>
                <p>An administrator for your Azure tenant must grant "Compliance Guardian" permission to read audit logs. Click the button below to start the process.</p>
                <a href={consentUrl} target="_blank" rel="noopener noreferrer" className="button">
                    Grant Admin Consent
                </a>
                <p className="small-text">(This will open a new tab. Please complete the consent process there and then return to this page to continue.)</p>
            </div>

            <div className="onboarding-step">
                <h3>Step 2: Configure Your Workspace</h3>
                <p>After granting consent, please enter your organization's details below.</p>
                <form onSubmit={handleSubmit} className="onboarding-form">
                    <div className="form-field">
                        <label htmlFor="orgName">Organization Name:</label>
                        <input
                            id="orgName"
                            type="text"
                            placeholder="e.g., Hope Creek Hospital"
                            value={orgName}
                            onChange={(e) => setOrgName(e.target.value)}
                            required
                        />
                    </div>

                    <div className="form-field">
                        <label htmlFor="tenantId">Your Azure Tenant ID:</label>
                        <input
                            id="tenantId"
                            type="text"
                            placeholder="Paste your Azure Tenant ID here"
                            value={tenantId}
                            onChange={(e) => setTenantId(e.target.value)}
                            required
                        />
                    </div>

                    <div className="form-field">
                        <label htmlFor="workspaceId">Log Analytics Workspace ID:</label>
                        <input
                            id="workspaceId"
                            type="text"
                            placeholder="Paste your Log Analytics Workspace ID here"
                            value={workspaceId}
                            onChange={(e) => setWorkspaceId(e.target.value)}
                            required
                        />
                    </div>
                    
                    {error && <p className="error">Setup Failed: {error}</p>}
                    
                    <button type="submit" disabled={isLoading}>
                        {/* Updated button text */}
                        {isLoading ? 'Saving...' : 'Complete Setup & Go to Pricing'}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default Onboarding;